import { getAPIHeaderOptions, transformErrorResponse } from "../../utils/apiUtils";
import {
	ICreateMyGateDeviceRequestData,
	IEditMyGateDeviceRequestData,
	IGetMyGateDevicesResponseData,
	IGetSyncStatusResponseData,
	IMyGateDeviceDetails,
	IStartOTSSyncFailedResponseData,
	IStartOTSSyncRequestData,
	IStartOTSSyncSuccessResponseData,
	IUpdateConfigRequestData,
	IUpdateSocietyConfigRequestData,
	IUpdateSocietyConfigResponseData
} from "../../interfaces";
import { queries } from "./queries.reducer";

const ots = queries.injectEndpoints({
	endpoints: (builder) => ({
		// UPDATE CONFIG
		updateConfig: builder.mutation<unknown, IUpdateConfigRequestData>({
			query: (requestData) => ({
				url: "/settings/config/1",
				headers: getAPIHeaderOptions(true),
				method: "PATCH",
				body: requestData
			}),
			transformErrorResponse: transformErrorResponse
		}),

		// UPDATE SOCIETY CONFIG
		updateSocietyConfig: builder.mutation<IUpdateSocietyConfigResponseData, IUpdateSocietyConfigRequestData>({
			query: (requestData) => ({
				url: "/analytics/society",
				headers: getAPIHeaderOptions(true),
				method: "POST",
				body: requestData
			}),
			transformErrorResponse: transformErrorResponse
		}),

		// EDIT SOCIETY CONFIG
		editSocietyConfig: builder.mutation<unknown, { id: number; data: IUpdateSocietyConfigRequestData }>({
			query: (requestData) => ({
				url: `/analytics/society/${requestData.id}`,
				headers: getAPIHeaderOptions(true),
				method: "PATCH",
				body: requestData.data
			}),
			transformErrorResponse: transformErrorResponse
		}),

		// START OTS SYNC
		startOTSSync: builder.mutation<
			IStartOTSSyncSuccessResponseData | IStartOTSSyncFailedResponseData,
			IStartOTSSyncRequestData
		>({
			query: (requestData) => ({
				url: "/sync/sync_table/ots_sync",
				headers: getAPIHeaderOptions(true),
				method: "POST",
				body: requestData
			}),
			transformErrorResponse: transformErrorResponse
		}),

		// GET SYNC STATUS
		getSyncStatus: builder.query<IGetSyncStatusResponseData, void>({
			query: () => ({
				url: "/sync/sync_table/get_sync_status",
				headers: getAPIHeaderOptions(true),
				method: "GET"
			})
		}),

		// CREATE MYGATE DEVICE
		createMyGateDevice: builder.mutation<IMyGateDeviceDetails, ICreateMyGateDeviceRequestData>({
			query: (requestData) => ({
				url: "/analytics/mygate-setting",
				headers: getAPIHeaderOptions(true),
				method: "POST",
				body: requestData
			}),
			transformErrorResponse: transformErrorResponse
		}),

		// GET MYGATE DEVICES
		getMyGateDevices: builder.query<IGetMyGateDevicesResponseData, void>({
			query: () => ({
				url: "/analytics/mygate-setting",
				headers: getAPIHeaderOptions(true),
				method: "GET"
			})
		}),

		// EDIT MYGATE DEVICE
		editMyGateDevice: builder.mutation<IMyGateDeviceDetails, IEditMyGateDeviceRequestData>({
			query: (requestData) => ({
				url: `/analytics/mygate-setting/${requestData.id}`,
				headers: getAPIHeaderOptions(true),
				method: "PATCH",
				body: requestData.data
			}),
			transformErrorResponse: transformErrorResponse
		}),

		// RESTART BACKGROUND JOBS
		restartBackgroundJobs: builder.mutation<unknown, void>({
			query: () => ({
				url: "/settings/restart-background-jobs",
				headers: getAPIHeaderOptions(true),
				method: "POST"
			}),
			transformErrorResponse: transformErrorResponse
		}),

		// UPDATE SYNC CONTROLLER
		updateSyncController: builder.mutation<unknown, void>({
			query: () => ({
				url: "/sync/update_sync_table",
				headers: getAPIHeaderOptions(true),
				method: "POST"
			}),
			transformErrorResponse: transformErrorResponse
		})
	})
});

export const {
	// UPDATE CONFIG
	useUpdateConfigMutation,
	// UPDATE SOCIETY CONFIG
	useUpdateSocietyConfigMutation,
	// START OTS SYNC
	useStartOTSSyncMutation,
	// GET SYNC STATUS
	useLazyGetSyncStatusQuery,
	// EDIT SOCIETY CONFIG
	useEditSocietyConfigMutation,
	// CREATE MYGATE DEVICE
	useCreateMyGateDeviceMutation,
	// GET MYGATE DEVICES
	useGetMyGateDevicesQuery,
	// EDIT MYGATE DEVICE
	useEditMyGateDeviceMutation,
	// RESTART BACKGROUND JOBS
	useRestartBackgroundJobsMutation,
	// UPDATE SYNC CONTROLLER
	useUpdateSyncControllerMutation
} = ots;

export default ots;
